/**
 * Device identity management.
 * Provides localStorage fallback for device_id when cookies are unavailable.
 */

const DEVICE_ID_KEY = 'device_id';

/**
 * Get the device ID from localStorage (fallback storage).
 */
export function getStoredDeviceId(): string | null {
    try {
        return localStorage.getItem(DEVICE_ID_KEY);
    } catch {
        return null;
    }
}

/**
 * Store the device ID in localStorage (fallback storage).
 */
export function setStoredDeviceId(deviceId: string): void {
    try {
        localStorage.setItem(DEVICE_ID_KEY, deviceId);
    } catch {
        // localStorage may be unavailable in some contexts
    }
}
